/**
 * Login page.
 * Email/password auth via Supabase.
 */

import { getSupabase } from '../services/supabase.js';
import { login } from '../services/auth.js';
import { navigate } from '../services/router.js';
import { renderLoginSidebar, renderSidebar, initSidebarListeners } from '../components/sidebar.js';

export function renderLogin() {
  const app = document.getElementById('app');

  // Show brand-only sidebar (no nav links)
  const sidebar = document.getElementById('sidebar');
  if (sidebar) {
    sidebar.innerHTML = renderLoginSidebar();
    sidebar.classList.remove('sidebar--collapsed');
  }
  // Hide hamburger on login (no nav to toggle)
  const hamburger = document.querySelector('.sidebar__hamburger');
  if (hamburger) hamburger.style.display = 'none';

  app.innerHTML = `
    <div class="login-page">
      <div class="card login-card">
        <img src="/brand/logo3.png" alt="AlliAvia" class="login-logo" />
        <form id="login-form">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" required autocomplete="email" />
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" id="password" required autocomplete="current-password" />
          </div>
          <div id="login-error" style="color: var(--color-danger); margin-bottom: 1rem; display: none;"></div>
          <button type="submit" class="btn btn--primary" style="width: 100%;">Log In</button>
        </form>
      </div>
    </div>
  `;

  document.getElementById('login-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;
    const errorEl = document.getElementById('login-error');

    try {
      await login(getSupabase(), email, password);
      // Eagerly re-render sidebar with role-filtered links before navigating.
      // login() has already set currentUser/currentRole synchronously.
      const sidebarEl = document.getElementById('sidebar');
      if (sidebarEl) {
        const collapsed = localStorage.getItem('sidebar-collapsed') === 'true';
        sidebarEl.innerHTML = renderSidebar('/', collapsed);
        initSidebarListeners();
      }
      const hamburger = document.querySelector('.sidebar__hamburger');
      if (hamburger) hamburger.style.display = '';
      navigate('/');
    } catch (err) {
      errorEl.textContent = err.message;
      errorEl.style.display = 'block';
    }
  });
}
